import { WidgetDataType, WidgetNoneType } from '@atlas-metrics/microsite-types';
import React, { useEffect, useState } from 'react';

import { FormatValueFn } from '@/hooks/useFormatValue';

import { primaryColors, secondaryColors } from '@/styles/colorSchemes';

import ChartLegend from './ChartLegend';
import { ProgressChart } from './ProgressChart';
import { randomizeChartColorsStartIdx } from './utils';
import HorizontalDivider from '../ui/HorizontalDivider';

import { ProgressChartDisclosureResult } from '@/types';

type Props = {
  data: ProgressChartDisclosureResult[];
  dataType: WidgetDataType | WidgetNoneType;
  formatValue: FormatValueFn;
};

export const ProgressChartWithLegends: React.FC<Props> = ({
  data,
  dataType,
  formatValue,
}) => {
  const [dataColorsSet, setDataColorsSet] =
    useState<ProgressChartDisclosureResult[]>();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  useEffect(() => {
    // colors set should be random for each chart
    const chartColorsStartIdx = randomizeChartColorsStartIdx(data);
    const colors = [
      ...primaryColors.slice(chartColorsStartIdx),
      ...primaryColors.slice(0, chartColorsStartIdx),
      ...secondaryColors,
    ];
    const dataWithColors = data.map((data, index) => ({
      ...data,
      color: colors[index],
    }));
    setDataColorsSet(dataWithColors);
  }, [data]);

  function handleHover(index: number) {
    setActiveIndex(index);
  }

  function clearHover() {
    setActiveIndex(null);
  }

  return (
    <>
      <ProgressChart
        data={dataColorsSet && dataColorsSet}
        onMouseOver={handleHover}
        onMouseOut={clearHover}
        activeIndex={activeIndex}
      />
      <HorizontalDivider className='mx-4' />
      <div className='m-4 grid gap-y-2'>
        {dataColorsSet?.map((d, i) => (
          <ChartLegend
            title={d.name}
            dataType={dataType}
            number={d.percentage}
            formatValue={formatValue}
            key={i}
            color={d.color && d.color}
            onMouseOver={() => handleHover(i)}
            onMouseOut={clearHover}
            className={activeIndex === i ? 'bg-ds-grey-50' : undefined}
          />
        ))}
      </div>
    </>
  );
};
